import { i18n } from '@/i18n'
const data = {
  data: [
    {
      IdGrupo: 1,
      Empresa: 'EmpresaPrueba',
      Nombre: 'GrupoPrueba1',
      idTipo: 1,
      Usuarios: ['eusebio.gomez'],
      Estados: [],
      EnUso: true,
      VerTodoGrupos: true,
      VerTodoEstados: true,
      VerTodoEmpresas: true,
      idCliente: 1,
      active: true,
    },
    {
      IdGrupo: 2,
      Empresa: 'EmpresaPrueba',
      Nombre: 'GrupoPrueba2',
      idTipo: 2,
      Usuarios: ['ramon.garcia'],
      Estados: [
        {
          id: 0,
          Nombre: i18n.t('tipos.estado_emitidas.not_sent'),
          Info: i18n.t('tipos.estado_emitidas.not_sent_info'),
          Modulo: [0],
          Regla: true,
        },
        {
          id: 1,
          Nombre: i18n.t('tipos.estado_emitidas.shipping_order'),
          Info: i18n.t('tipos.estado_emitidas.shipping_order_info'),
          Modulo: [0],
          Regla: true,
        }
      ],
      EnUso: true,
      VerTodoGrupos: true,
      VerTodoEstados: true,
      VerTodoEmpresas: true,
      idCliente: 1,
      active: true,
    },
    {
      IdGrupo: 3,
      Empresa: 'EmpresaPrueba',
      Nombre: 'GrupoPrueba3',
      idTipo: 2,
      Usuarios: ['carlos.santos'],
      Estados: [
        {
          id: 12,
          Nombre: i18n.t('tipos.estado_recibidas.ocr'),
          Info: i18n.t('tipos.estado_recibidas.ocr_info'),
          Modulo: [1],
          Regla: false,
        },
        {
          id: 13,
          Nombre: i18n.t('tipos.estado_recibidas.wait_erp_sent'),
          Info: i18n.t('tipos.estado_recibidas.wait_erp_sent_info'),
          Modulo: [2],
          Regla: true,
        },
      ],
      EnUso: true,
      VerTodoGrupos: true,
      VerTodoEstados: true,
      VerTodoEmpresas: true,
      idCliente: 1,
      active: true,
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
